module.exports = __webpack_public_path__ + "static/media/desktop.0ece97ff.svg";